import { Injectable, inject } from '@angular/core';
import { AssignmentProcessService } from '@6grain/masofa-monolith-api-client/common/api/assignmentProcess.service';
import { StartAssignmentProcessRequest } from '@6grain/masofa-monolith-api-client/common/model/startAssignmentProcessRequest';
import { Observable, map } from 'rxjs';
import { FIND_PRODUCTS_PROCESS_KEY, SatelliteProcessParameters } from '../utils/processing-request-params.util';

/**
 * Starts the satellite-image search for a map request: `satellite.find-products` through the
 * generated assignments API. Downloading found products is a separate existing process.
 */
@Injectable({ providedIn: 'root' })
export class SatelliteProcessingRequestService {
  private readonly assignments = inject(AssignmentProcessService);

  /** Starts the search and returns its assignment id (null when the server omits it). */
  startRequest(parameters: SatelliteProcessParameters): Observable<string | null> {
    const request: StartAssignmentProcessRequest = { parameters };
    return this.assignments
      .assignmentsProcessesProcessKeyPost(FIND_PRODUCTS_PROCESS_KEY, request)
      .pipe(map((response) => readAssignmentId(response)));
  }
}

/** The generated client types the response as `any`; this is the minimal shape the server returns (202). */
interface StartedAssignmentBody {
  assignmentId?: unknown;
  AssignmentId?: unknown;
}

function readAssignmentId(response: unknown): string | null {
  const body = (typeof response === 'object' ? response : null) as StartedAssignmentBody | null;
  const id = body?.assignmentId ?? body?.AssignmentId;
  return typeof id === 'string' && id ? id : null;
}
